import React, {useState} from "react";
import PropTypes from "prop-types";
import {
  Button,
  Box,
  Tab,
  Tabs,
  AppBar,
  makeStyles,
  ButtonGroup,
  Zoom,
  useTheme,
  Typography,
} from "@material-ui/core";

import {COLORS} from "../../utils/colors";
import {FiberManualRecord} from "@material-ui/icons";

function TabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

export default function UltimateTrousersPalettePicker(props) {
  const classes = useStyles();
  const theme = useTheme();

  const [base, setBase] = useState("black");
  const [contrast, setContrast] = useState("black");
  const [stitching, setStitching] = useState("black");
  const [patch, setPatch] = useState("black");

  const handleChange = (event, newValue) => {
    props.setSelectedPart(newValue);
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  const getColor = (label) => {
    switch (label) {
      case "base":
        return base;
      case "contrast":
        return contrast;
      case "stitching":
        return stitching;
      case "patch":
        return patch;

      default:
        return "black";
    }
  };

  const changeColor = (label, col) => {
    switch (label) {
      case "base":
        setBase(col);
        break;
      case "contrast":
        setContrast(col);
        break;
      case "stitching":
        setStitching(col);
        break;
      case "patch":
        setPatch(col);
        break;

      default:
        return;
    }
  };

  const renderProtective = (color) => {
    return (
      <div>
        <Typography variant="h5" style={{marginTop: "25px"}}>
          Protective patch material
        </Typography>

        <Zoom
          in={props.selectedPart === color.label}
          timeout={transitionDuration}
          style={{
            marginTop: "10px",
            transitionDelay: `${
              props.selectedPart === color.label ? transitionDuration.exit : 0
            }ms`,
          }}
          unmountOnExit
        >
          <Box
            display="flex"
            flexWrap="wrap"
            p={1}
            m={1}
            bgcolor="background.paper"
            style={{
              maxWidth: "100%",
              paddingleft: "150px",
            }}
          >
            {color.protective.map((col, index) => (
              <Button
                key={index}
                onClick={() => {
                  color.cb(col);
                }}
                style={{
                  color: "transparent",
                  background: col,
                  height: "55px",
                  width: "22%",
                  margin: "5px",
                }}
              >
                COLOR
              </Button>
            ))}
          </Box>
        </Zoom>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={props.selectedPart}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="palette picker"
          style={{indicator: "red"}}
        >
          {props.tabs.map((tab, index) => {
            return (
              <Tab
                id={index}
                icon={
                  <FiberManualRecord
                    id={index}
                    key={tab.label}
                    style={{fill: getColor(tab.label)}}
                  />
                }
                key={tab.label}
                label={tab.tabName}
                {...a11yProps(tab.label)}
                value={tab.label}
              />
            );
          })}
        </Tabs>
      </AppBar>
      {props.colorTabs.map((color, index) => (
        <TabPanel key={index} value={props.selectedPart} index={color.label}>
          <Zoom
            in={props.selectedPart === color.label}
            timeout={transitionDuration}
            style={{
              transitionDelay: `${
                props.selectedPart === color.label ? transitionDuration.exit : 0
              }ms`,
            }}
            unmountOnExit
          >
            <Box
              display="flex"
              flexWrap="wrap"
              p={1}
              m={1}
              bgcolor="background.paper"
              style={{
                maxWidth: "100%",
                paddingleft: "150px",
              }}
            >
              {color.colors.map((col, index) => (
                <Button
                  focusRipple={true}
                  disableRipple={false}
                  disableTouchRipple={false}
                  variant="contained"
                  key={index}
                  onClick={() => {
                    changeColor(color.label, col);
                    color.cb(col);
                    if (color.label === "contrast" && col === COLORS.black.value) {
                      if (props.azomo) {
                        props.azomo(COLORS.white.value);
                      }
                    } else if (color.label === "contrast" && col !== COLORS.black.value) {
                      if (props.azomo) {
                        props.azomo(COLORS.black.value);
                      }
                    }
                  }}
                  style={{
                    color: "transparent",
                    background: col,
                    height: "55px",
                    width: "22%",
                    margin: "5px",
                  }}
                >
                  COLOR
                </Button>
              ))}
            </Box>
          </Zoom>

          {color.protective ? renderProtective(color) : null}
        </TabPanel>
      ))}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  roundButton: {
    backgroundColor: "rgb(205, 97, 85)",
    color: "transparent",
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  buttons: {
    backgroundColor: "rgb(205, 97, 85)",
    color: "transparent",
  },
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
